import React from 'react';
import Tabs from '../ui/Tabs';
import { useIsMobileOrderViewport } from '../../hooks/useIsMobileOrderViewport';

// The three task views the gag/team task board offers. The Timeline (a Gantt)
// is unusable on narrow viewports (fixed label column + wide timeline) so its
// tab is not offered below md — the caller is responsible for the actual
// view→list fallback when the viewport shrinks (this component only drops the
// tab). The view's ID stays 'gantt'; only the label reads "Timeline" (owner
// 2026-10-12, matching My Tasks and the Breakdown).
const TASK_VIEW_TABS = [
  { id: 'list', label: 'Table' },
  { id: 'kanban', label: 'Kanban' },
  { id: 'gantt', label: 'Timeline' },
];

/**
 * Table / Kanban / Timeline switcher for the gag/team task board
 * (TeamTaskBoard), in the house tab design: `ui/Tabs` in `bare` mode, so it
 * shares a line with whatever the caller puts beside it (owner 2026-10-12:
 * *"use our common tab design"*). My Tasks has its own `ui/Tabs` (Table |
 * Kanban | Timeline), the same labels (owner 2026-10-12). Left-aligned by convention (the caller places it).
 *
 * Props:
 *  - value: 'list' | 'kanban' | 'gantt' — the active view.
 *  - onChange(v): called with the tapped tab's id.
 *  - idPrefix: unique per board on the page (tab ids derive from it).
 */
export default function TaskViewSwitcher({ value, onChange, idPrefix = 'task-view' }) {
  const isMobile = useIsMobileOrderViewport();
  const tabs = isMobile ? TASK_VIEW_TABS.filter((t) => t.id !== 'gantt') : TASK_VIEW_TABS;
  return (
    <Tabs bare className="shrink-0" tabs={tabs} active={value} onChange={onChange}
      idPrefix={idPrefix} ariaLabel="Task view" />
  );
}
